import { DeferredPage } from "@/components/data-display/deferred-page";

// Deferred (page-delivery-pipeline.md G6, 2026-09-23). No treasury backend exists in this
// environment: intent lifecycle state, approval routing, and the approver name shown here
// were previously fabricated. See context/page_pipeline/BOARD.md wave 4 and
// context/page_pipeline/BACKEND_GAPS.md.
export default function TreasuryIntentPage() {
  return (
    <DeferredPage
      nav={{ kind: "breadcrumb", parents: [{ label: "Treasury", href: "/treasury" }, { label: "Opportunity Queue", href: "/treasury/opportunities" }], label: "Treasury Intent Detail" }}
      state={{
        title: "Intent detail is not available in this environment yet",
        description: "The full lifecycle view for a treasury intent — state machine, approval routing, and policy evaluation — requires the intent/approval backend, which does not exist in this environment yet.",
      }}
    />
  );
}
